import '@mortalarc/util/dist/BaseStyle.css'
import '@/assets/index.css'
import { createApp } from 'vue'
import Main from './Main.vue'

const app = createApp(Main)
app.config.globalProperties.window = window
app.mount('#app')
